import { HttpStatusCode, isAxiosError, type AxiosInstance } from "axios";
import { type StoredPicturesDownloadCondition } from "@/types/storedPicturesDownloadCondition";
import { type NavigateFunction } from "react-router-dom";
import { toast } from "react-toastify";
import { READ_ONLY_TOOLTIP_MESSAGE } from "@/utils/permissions";

export const downloadStoredPicturesAPI = async (
  apiClient: AxiosInstance,
  downloadCondition: StoredPicturesDownloadCondition,
  navigate: NavigateFunction
): Promise<void> => {
  const data = {
    billableData: downloadCondition.billableData.map((element) => {
      return {
        id: element.receivedId,
      };
    }),
    noBillableData: downloadCondition.noBillableData,
  };

  await apiClient
    .post<{ pictureRequestId: number }>(
      "/picture-request/stored-pictures/download",
      data
    )
    .then((result) => {
      if (result.status !== HttpStatusCode.Ok) {
        toast.error("登記のダウンロードに失敗しました");
      }
      // 詳細画面に遷移。
      navigate(`/acquirebookstatus/${result.data.pictureRequestId}/`);
    })
    .catch((error) => {
      if (
        isAxiosError(error) &&
        error.response?.status === HttpStatusCode.Forbidden
      ) {
        toast.error(READ_ONLY_TOOLTIP_MESSAGE);
        return;
      }

      toast.error("登記のダウンロードに失敗しました");
    });
};
